module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kate Griffin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Kate Griffin")]), _vm._v(" is the name under which Carnegie Medal-nominated author Catherine Webb writes fantasy novels for adults. An acclaimed author of young adult books under her own name, Catherine's amazing debut, "), _c('I', [_vm._v("Mirror Dreams")]), _vm._v(", was written when she was only fourteen years old, and garnered comparisons with Terry Pratchett and Philip Pullman.  She read History at the London School of Economics, and studied at RADA. Find out more about the author at www.kategriffin.net.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17ejyWY/tc-custom/9780316231749.jpg?1732976220581",
      "alt": "This image is the cover for the book Stray Souls, Magicals Anonymous"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Stray Souls, Magicals Anonymous\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("LONDON'S SOUL IS MISSING."), _c('br'), _c('br'), _vm._v("When Sharon Li unexpectedly discovers she's a shaman, it's not a moment too soon: London's soul is lost. Using her newfound oneness with the City, she sets about saving London from inevitable demise, but the problem is she has no clue where to start. Meanwhile, a mysterious gate has opened, and there are creatures loose that won't wait for her to catch up before they go out hunting. Now Sharon and her motley crew of magical misfits must find a way to save the world. . .")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Orbit\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0